<style scoped> 
    .label {
        font-weight: 600;
    }
</style>
<template>
    <div class="form-group">
        <label class="label required">{{ $t("Customer") }}</label>
        <app-input
            :placeholder="$t('Select customer')"
            type="advance-search-select"
            fetch-url="/companies_customer/serverside/selectable-name"
            listValueField="Title"
            v-model="selected"
            :required="true"
            :loaded-per-time="5"
            :disabled="is_view"
        />   
	</div>
</template>
  
<script>
    export default {
        name: 'Customer',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
            is_view : {
                type: Boolean,
                default : false,
            }
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        },
        mounted(){ }
    }
</script>